export interface RegionSuggestElem {
    title: string;
    subtitle: string;
    geoid: number;
}

export enum RegionInputIds {
    FreelancerRegionInputId = 'FreelancerRegionInputId'
}

export interface Region {
    text: string;
    suggestList: RegionSuggestElem[];
    hasError: boolean;
    geoId?: number;
}

export type RegionsState = { [key in keyof typeof RegionInputIds]: Region };
